<template>
  <div class="main-box">
    <div class="player-stream">
      <div class="player-title ">
        <div class="player-title-text text">
          {{stream_camera_selected.camera.camera_info[0].name}}
        </div>
      </div>  
        <div class="player">
          <!-- <video id="video-stream"  class="video-js" controls></video>  -->
          <video ref='Player' id="video-stream"  class="video-js vjs-big-play-centered" controls></video> 
        </div>
    </div>
  </div>  
</template>

<script>
import videojs from 'video.js';
import videojsPlaylist from 'videojs-playlist'
videojs.registerPlugin('videojs-playlist', videojsPlaylist);

// const videojsPlaylist = require('videojs-playlist');

  export default {

    name: 'StreamComponent',


    props: ['stream_camera_selected',],

    data() {
      return {
        player: null,
        camera_uid: '',
        last_time: '',
      };
    },

    mounted () {
      this.start_player()
    },

    methods: {

      new_connect () {
        this.$emit('end_playlist', {
          last_time:this.last_time,
          camera_uid:this.camera_uid
        })
      },

      start_player () {
        if (this.stream_camera_selected.play_list.length == 0) {
          this.last_time = 0
        } else {
          this.last_time = this.stream_camera_selected.play_list[this.stream_camera_selected.play_list.length - 1]
        }
        this.camera_uid = this.stream_camera_selected.camera_uid
        let self = this
        if (this.stream_camera_selected.play_list.length > 0 ) {
          let count_playlist_videos = this.stream_camera_selected.play_list.length
          let local_playlist = []
          
          // this.player = videojs('video-stream', {
          this.player = videojs(this.$refs.Player, {
            autoplay: true,
            controls: true,
            fluid: true,
            fill: true,
            responsive: true,
            errorDisplay: false,
            aspectRatio: '16:10',
          })

          for (let url in this.stream_camera_selected.play_list) {
            local_playlist.push({
              sources: [{
                src: this.stream_camera_selected.play_list[url],
                type: 'video/mp4'
              }]
            })
          }
          this.player.playlist(local_playlist)
          this.player.playlist.autoadvance(0);
          this.player.responsive(true);
          this.player.fill(true);
          this.player.fluid(true);

          this.player.ready(function() {
            this.on("ended", function(){ 
              count_playlist_videos -= 1
              console.log(count_playlist_videos)
              if (count_playlist_videos === 0) {
                self.new_connect()
              }
            });
          });

        } else {
          this.player = videojs('video-stream', {
            autoplay: true,
            controls: true,
            fluid: true,
            fill: true,
            responsive: true,
            errorDisplay: false,
            aspectRatio: '16:10',
            sources: [
              {
                src: this.stream_camera_selected.camera.hlsurl,
                type: "application/x-mpegURL"
              }
            ]
          })
        }
      },

    },

  beforeUnmount() {
      this.player.dispose()
  } 

  };
</script>

<style scoped>

  .main-box {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 23px;
  }

  .player-title {
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
    background: #383838;
    border-radius: 5px;
    width: 95%;
    height: 30px;
  }

  .player-title-text {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    padding-top: 6px;
  }

  .player-stream {
    display: grid;
    grid-template-columns: 1fr;
    gap: 15px;
    grid-template-rows: 0.01fr 1fr;
    justify-items: center;
  }

  .player {
    border-radius: 5px 5px 0px  0px;
    height: auto;
    width: 75%;
  }

  @media (max-width: 700px) {

    .main-box {
      margin-top: 10px;
      margin-left: 30px;
      margin-right: 30px;
    }

    .player {
      margin-top: 10px;
    }
  }


  @media (max-width: 600px) {

    .main-box {
      margin-top: 5px;
      margin-left: 20px;
      margin-right: 20px;
    }

    .player {
      margin-top: 5px;
    }

  }

  @media (max-width: 450px) {
    .player {
      margin-top: 0;
      width: 95%;
    }
  }

</style>
